import React, { memo } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box } from 'transfix-ui/core'
import * as Types from 'apps/fleet-planner/types'

interface ShareLoadAssignDriverCheckboxProps {
  selectedDriver: Types.IDriver | undefined
  assignedDriver: Types.IDriver | undefined
  isLoading?: boolean
  isAssignDriverCheckboxChecked: boolean
  onChangeCheckbox: () => void
}

export const ShareLoadAssignDriverCheckbox = memo<ShareLoadAssignDriverCheckboxProps>(
  ({
    assignedDriver,
    isAssignDriverCheckboxChecked,
    isLoading,
    onChangeCheckbox,
    selectedDriver,
  }) => {
    const { id: selectedDriverId } = selectedDriver || {}
    const { id: assignedDriverId } = assignedDriver || {}
    const isSelectedDriverAssignable = selectedDriverId && !assignedDriverId

    return (
      <>
        {isSelectedDriverAssignable && (
          <>
            <Box mt={2} ml={0.5} mb={isAssignDriverCheckboxChecked ? 0 : 2}>
              <Checkbox
                checked={isAssignDriverCheckboxChecked}
                defaultChecked={isAssignDriverCheckboxChecked}
                disabled={isLoading}
                label='Check here to assign this driver to this load'
                onChange={onChangeCheckbox}
              />
            </Box>
            {!isAssignDriverCheckboxChecked && (
              <InlineMessage
                type={INLINE_MESSAGE_VARIANTS.WARNING}
                message='Note: The driver will not be able to submit status updates unless you assign them to this load.'
              />
            )}
          </>
        )}
      </>
    )
  }
)
